<script>
    export let html
    export let header = "Screenshot"
</script>

<h1>{header}</h1>
<div class="">
    {@html html}
</div>
